
// src/services/api.js
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_URL;
// console.log({ API_BASE_URL });
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
    }
    return Promise.reject(error);
  }
);

export const apiService = {
  getProfile: async (config = {}) => {
    const response = await api.get("/auth/profile", config);
    return response.data ?? {};
  },

  getCMSDetails: async (slug) => {
    const response = await api.get(`/admin/cms/cms-by-slug?slug=${slug}`);
    console.log("my cms response=>>>>>>", response.data?.data);
    return response ?? {};
  },
  
  
// POST /admin/user-listing/update-payment-system
// POST /admin/user-listing/update-payment-system
updatePaymentSystem: async (payload = {}) => {
  const response = await api.put(
    "/admin/user-listing/update-payment-system",
    payload
  );
  // assuming backend returns something like { error, status, message, data }
  return response.data ?? {};
},

deleteAccount: async (payload = {}) => {
  const response = await api.delete(
    "/auth/delete-account-user",
    {
      data: payload, // axios DELETE requires data wrapper
    }
  );

  // assuming backend returns { error, status, message, data }
  return response.data ?? {};
},



geoLocateAddress: async (payload = {}) => {
  const response = await api.post(
    "/admin/user-listing/geo-location",
    payload
  );
  return response.data ?? {};
},



  updateProfile: async (payload, config = {}) => {
    const response = await api.put("/auth/update-profile", payload, config);
    return response.data ?? {};
  },

  getOrders: async (config = {}) => {
    const response = await api.get("/admin/booking/bookings", config);
    return response.data ?? {};
  },

  getDashBoardStats: async () => {
    const response = await api.get("/admin/user-listing/admin-dashboard-stats");
    return response.data?.data ?? response.data ?? {};
  },

  getManagerDailyRecords: async () => {
    const response = await api.get("/admin/user-listing/manager-daily-records");
    return response.data?.data ?? {};
  },

  redeemLoyaltyPoints: async () => {
    const response = await api.post("/admin/user-listing/redeem-loyalty-points");
    return response.data ?? {};
  },
  createCms: async (payload) => {
    const resp = await api.post("/admin/cms/create", payload);
    return resp.data ?? {};
  },
  listCms: async (params = {}) => {
    const resp = await api.get("/admin/cms/listing", { params });
  
    // server wraps data inside resp.data.data
    const wrapper = resp.data ?? {};
  
    return {
      data: wrapper.data?.data ?? wrapper.data ?? [],
      total: wrapper.data?.total ?? 0,
      totalPages: wrapper.data?.totalPages ?? 1,
    };
  },
  updateCms: async (cmsId, payload) => {
    const resp = await api.put(`/admin/cms/edit/${cmsId}`, payload);
    return resp.data ?? {};
  },
  deleteCms: async (cmsId) => {
    const resp = await api.delete(`/admin/cms/delete/${cmsId}`);
    return resp.data ?? {};
  },
  getCmsById: async (cmsId) => {
    const resp = await api.get(`/admin/cms/get-by-id/${cmsId}`);
    return resp.data ?? {};
  },
          

  getManagerOrders: async (config = {}) => {
    const response = await api.get("/admin/booking/manager-bookings", config);
    return response.data ?? {};
  },

  acceptBooking: async (bookingId) => {
    if (!bookingId) throw new Error("bookingId required for acceptBooking");
    const response = await api.put(`/admin/booking/accept/${bookingId}`);
    return response.data ?? {};
  },

  cancelBooking: async (bookingId) => {
    if (!bookingId) throw new Error("bookingId required for cancelBooking");
    const response = await api.put(`/admin/booking/cancel/${bookingId}`);
    return response.data ?? {};
  },

  completeBooking: async (bookingId, { otp = "", billImage = null } = {}) => {
    if (!bookingId) throw new Error("bookingId required for completeBooking");

    if (billImage) {
      const form = new FormData();
      form.append("otp", otp ?? "");
      form.append("billImage", billImage);
      const response = await api.put(`/admin/booking/complete/${bookingId}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data ?? {};
    }

    const response = await api.put(`/admin/booking/complete/${bookingId}`, { otp });
    return response.data ?? {};
  },

  getPumps: async () => {
    const response = await api.get("/admin/pump/get-pump");
    console.log("pumps response=>>>>>>************", response.data?.data);
    return response.data.data ?? [];
  },

  getPumpsForManager: async () => {
    try {
      const response = await api.get("/admin/pump/get-pump-manager");
  
      console.log("🚀 getPumpsForManager response >>>>", response.data?.data);
  
      return response.data ?? [];
    } catch (error) {
      console.error("❌ Error fetching pump manager data:", error);
      return [];
    }
  },
  

  getUsers: async () => {
    const response = await api.get("/admin/user-listing/list-users");
    return response.data ?? {};
  },
  

  getManagers: async (params = {}) => {
    const response = await api.get("/admin/user-listing/list-users", { params });
    return response.data?.data ?? response.data ?? {};
  },

  getAgents: async (params = {}) => {
    const response = await api.get("/admin/user-listing/list-users", { params });
    return response.data?.data ?? response.data ?? {};
  },

  addUser: async (payload) => {
    const response = await api.post("/admin/user-listing/add-users", payload);
    return response.data ?? {};
  },

  // PUT /admin/user-listing/activate-deactivate-user/:userid
activateDeactivateUser: async (userId) => {
  if (!userId) throw new Error("userId required for activateDeactivateUser");
  const response = await api.post(`/admin/user-listing/activate-deactivate-user/${userId}`);
  return response.data ?? {};
},
// required additions to src/services/api.js
createPump: async (payload) => {
  const resp = await api.post("/admin/pump/add-pump", payload);
  return resp.data ?? {};
},
updatePump: async (pumpId, payload) => {
  const resp = await api.put(`/admin/pump/edit-pump/${pumpId}`, payload);
  return resp.data ?? {};
},
deletePump: async (pumpId) => {
  const resp = await api.delete(`/admin/pump/delete-pump/${pumpId}`);
  return resp.data ?? {};
},



  // NEW: get agent dashboard stats
  // Endpoint: GET /admin/user-listing/agent-dashboard-stats
  // Expected response (200): { error:false, status:200, message:"Success", data: { total_earnings, loyal_points_available, referred_count } }
  getAgentDashboardStats: async (config = {}) => {
    const response = await api.get("/admin/user-listing/agent-dashboard-stats", config);
    // return whole response or .data depending on consistency across the service
    return response.data?.data ?? response.data ?? {};
  },

  updateUserAdmin: async (userId, updateData) => {
    const response = await api.put(`/admin/user-listing/update-user/${userId}`, updateData);
    return response.data ?? {};
  },

  getAgentReferredCustomers: async (search = "") => {
    const url = "/admin/user-listing/agent-reffered-customers";
    const config = {};
    if (search && String(search).trim() !== "") {
      config.params = { search: String(search).trim() };
    }
    const response = await api.get(url, config);
    // backend response shape expected: { error:false, status:200, message:"Success", data: { agent_referral_code, data: [...] } }
    return response.data?.data ?? response.data ?? {};
  },

  // Get agent points and redemptions (server)
getAgentPointsAndRedemptions: async (config = {}) => {
  const response = await api.get("/admin/user-listing/agent-points-and-redemptions", config);
  // backend response shape: { error:false, status:200, message:"Success", data: { points_value, loyal_points_available } }
  return response.data?.data ?? response.data ?? {};
},

updatePump: async (pumpId, data) => {
  if (!pumpId) throw new Error("pumpId required for updatePump");
  return api.put(`/admin/pump/edit-pump/${pumpId}`, data);
},

getAgentPointsHistory: async (search = "") => {
  try {
    const response = await api.get(`/admin/user-listing/agent-points-history`, {
      params: { search },
    });
    return response.data;
  } catch (err) {
    console.error("API ERROR: getAgentPointsHistory →", err);
    throw err;
  }
},

getManagerPaymentHistory: async (search = "") => {
  try {
    // if your backend expects query param 'search' this will pass it
    const res = await api.get(`/admin/user-listing/manager-payment-history`, {
      params: { search },
    });

    // return the full response.data so callers get { error, status, message, data }
    return res.data;
  } catch (err) {
    console.error("API ERROR: getManagerPaymentHistory ->", err);
    throw err;
  }
},

// Get manager sales records (aggregates)
getManagerSalesRecords: async (params = {}) => {
  // If the backend needs managerId explicitly, pass it via params: { managerId }
  const response = await api.get("/admin/user-listing/manager-sales-records", { params });
  // expected backend response: { error:false, status:200, message:"Success", data: { totalOrders, totalVolume, totalEarnings, netPayable } }
  return response.data?.data ?? response.data ?? {};
},

  getAgentReceivableAmounts: async (search = "") => {
    const response = await api.get(
      `/admin/user-listing/get-agent-receivable-amount?search=${encodeURIComponent(search)}`
    );
    return response.data ?? {};
  },

  login: (credentials) => api.post("/admin/login", credentials),
  verifyOtp: (token, otp) => api.post("/auth/verify-otp", { token, otp }),
  logout: () => api.post("/auth/logout"),
};

export default apiService;






